import type { ModelConfigMapper } from "./model.type";

export const MODEL_CONFIG_MAPPER: ModelConfigMapper = {
  activity: {
    apiKey: "activities",
    queryKey: "activities",
    listRoute: "/admin/activities",
    itemRoute: "/admin/activities/:id",
    authorizationKeys: { create: null, update: null, view: "activity" },
    restore: true,
  },
  asset: {
    apiKey: "assets",
    queryKey: "assets",
    listRoute: "/org/:context/assets",
    itemRoute: "/org/:context/assets/:id",
    authorizationKeys: { create: "asset", update: null, view: null },
    deleteAsync: true,
    restore: true,
  },
  assettype: {
    apiKey: "assetTypes",
    queryKey: "assetTypes",
    listRoute: "/admin/asset-types",
    itemRoute: "/admin/asset-types/:id",
    authorizationKeys: { create: "assettype", update: null, view: null },
    translationKey: "assetType",
    restore: true,
  },
  comment: {
    apiKey: "comments",
    queryKey: "observations.comments",
    listRoute: null,
    itemRoute: null,
    authorizationKeys: { create: null, update: null, view: null },
    translationKey: "comment",
    restore: false,
  },
  dataset: {
    apiKey: "datasets",
    queryKey: "datasets",
    listRoute: null,
    itemRoute: null,
    authorizationKeys: { create: null, update: null, view: null },
    restore: true,
  },
  entitytemplate: {
    apiKey: "entityTemplates",
    queryKey: "entityTemplates",
    listRoute: null,
    itemRoute: null,
    authorizationKeys: { create: "entitytemplate", update: null, view: null },
    restore: false,
  },
  intervention: {
    apiKey: "interventions",
    queryKey: "interventions",
    listRoute: "/org/:context/interventions",
    itemRoute: "/org/:context/interventions/:id",
    authorizationKeys: { create: "intervention", update: null, view: null },
    restore: true,
  },
  interventiontemplate: {
    apiKey: "interventionTemplates",
    queryKey: "interventionTemplates",
    listRoute: "/admin/intervention-templates",
    itemRoute: "/admin/intervention-templates/:id",
    authorizationKeys: {
      create: "interventiontemplate",
      update: null,
      view: null,
    },
    translationKey: "interventionTemplate",
    restore: true,
  },
  jobmodule: {
    apiKey: "jobModules",
    queryKey: "jobModules",
    listRoute: null,
    itemRoute: null,
    authorizationKeys: { create: null, update: null, view: null },
    restore: false,
  },
  location: {
    apiKey: "locations",
    queryKey: "locations",
    listRoute: "/org/:context/locations",
    itemRoute: "/org/:context/locations/:id",
    authorizationKeys: { create: "location", update: null, view: "location" },
    deleteAsync: true,
    restore: true,
  },
  module: {
    apiKey: "modules",
    queryKey: "modules",
    listRoute: null,
    itemRoute: null,
    authorizationKeys: { create: null, update: null, view: null },
    restore: false,
  },
  observation: {
    apiKey: "observations",
    queryKey: "observations",
    listRoute: "/org/:context/observations",
    itemRoute: "/org/:context/observations/:id",
    authorizationKeys: { create: null, update: null, view: null },
    restore: false,
  },
  organization: {
    apiKey: "organizations",
    queryKey: "organizations",
    listRoute: "/admin/organizations",
    itemRoute: null,
    authorizationKeys: {
      create: "organization",
      update: "organization",
      view: "organization",
    },
    deleteAsync: true,
    restore: true,
  },
  project: {
    apiKey: "projects",
    queryKey: "projects",
    listRoute: "/org/:context/projects",
    itemRoute: "/org/:context/projects/:id",
    authorizationKeys: { create: "project", update: null, view: "project" },
    restore: true,
  },
  recommendation: {
    apiKey: "recommendations",
    queryKey: "recommendations",
    listRoute: null,
    itemRoute: null,
    authorizationKeys: { create: null, update: null, view: null },
    restore: true,
  },
  role: {
    apiKey: "roles",
    queryKey: "roles",
    listRoute: null,
    itemRoute: null,
    authorizationKeys: { create: null, update: null, view: null },
    restore: false,
  },
  sector: {
    apiKey: "locations",
    queryKey: "locations",
    listRoute: "/org/:context/locations",
    itemRoute: "/org/:context/locations/:id",
    authorizationKeys: { create: "location", update: null, view: "location" },
    translationKey: "sector",
    deleteAsync: true,
    restore: true,
  },
  severitygrid: {
    apiKey: "severityGrids",
    queryKey: "severityGrids",
    listRoute: null,
    itemRoute: null,
    authorizationKeys: { create: null, update: null, view: null },
    translationKey: "severityGrids",
    restore: false,
  },
  technicalform: {
    apiKey: "entityTemplates",
    queryKey: "entityTemplates",
    listRoute: "/admin/technical-forms",
    itemRoute: "/admin/technical-forms/:id",
    authorizationKeys: { create: "entitytemplate", update: null, view: null },
    translationKey: "technicalForm",
    restore: false,
  },
  user: {
    apiKey: "users",
    queryKey: "users",
    listRoute: "/admin/users",
    itemRoute: "/admin/users/:id",
    authorizationKeys: { create: "user", update: null, view: "user" },
    restore: true,
  },
};
